import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {Controller, useForm, useFieldArray} from "react-hook-form";
import classes from './form.module.scss';
import {useDispatch, useSelector} from 'react-redux';
import {dryCreation} from '../../../store/reducers/LaborantReducer/Form'
import Select from 'react-select'

import Paint from '@mui/icons-material/ImagesearchRollerOutlined';
import DryCut from '@mui/icons-material/ContentCutOutlined';
import WetCut from '@mui/icons-material/WaterDropOutlined';
import DisplayForm from '@mui/icons-material/DisplaySettings';
import PrintIcon from '@mui/icons-material/Print';
import TableInput from "../../TableInput";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import TablePrint from '../../TablePrint';
// import Signature from '../../Signature';
import {DoctorService} from "../../../api/DoctorService";
import { updateInput } from '../../../store/reducers/ScanReducer/RegistrationScanReducer';
import SmallLabForm from '../SmallLabForm'
import CassetsEdit from '../../CassetsEdit'
import { laborantService } from '../../../api/laborantService';

const Form = ({onPrinted, onChange, values, id, quant}) => {
        
    const [dataInputs, setDataInputs] = useState();
    const [levelsQuant, setLevelsQuant]= useState([])
    const [change, setChange] = useState(false)
    const [smallForm, setSmallForm] = useState(false)
    const [print, setPrint] = useState(false)
    const [labels, setLabels] = useState([])
    const [table, setTable] = useState(false)
    // const [sign, setSign] = useState(false)
    const form = useSelector(state => state.RegScan.ScanInputs)
    const [signData, setSignData] = useState()
    const [tableInput, setTableInput] = useState()
    const [edited, setEdited] = useState(false)
    const [tableForm, setTableForm] = useState([])

    const generateProps = (count) =>{
        const props = [];
        for (let i = 1; i <= count; i++) {
            props.push({
            register: `cassets${i}`,
            label: i,
            id: 770 + i,
            type: "text",
            placeholder: "Введіть опис"
            });
        }
        return props;
    }
    

    const onCloseDoc = (newCassettesCount) => {
        setTable(false)
        setChange(false)

        if (typeof newCassettesCount === 'number') {
            const updatedFields = values.fields.map(field => {
                if (field.name === 'cassetsAfter') {
                    return {
                    ...field,
                    props: generateProps(newCassettesCount)
                    }
                }
                return field;
                });
            setTableForm(updatedFields)
        }
    }

    const onChangeClose = () =>{
        setSmallForm(false)
    }

    const closePrint = () => {
        setPrint(false)
    }

    // const closeSign = () => {
    //     setSign(false)
    // }

    const {
        register,
        handleSubmit,
        formState: {errors},
        control,
        setValue
    } = useForm();

    useEffect(()=>{
        if(id){
        DoctorService.getDirection(id).then(res=>{
            if(res.data.research === 'Гістологія'){
                try{
                let obj1 = res.data.contract.agreements['Гістологія'].complexity
                let obj2 = res.data.contract.additionalAgreements['Гістологія'].complexity
                let levels = []
                const merged = Object.keys(obj1).reduce((acc, key) => {
                    acc[key] = obj1[key].quantity + obj2[key].quantity - obj1[key].usedCount + obj2[key].usedCount  
                    levels.push(acc[key])
                    return acc
                }, {});
                setLevelsQuant(levels)
                } catch(e){}
            }
        })
        }
    },[id])

    const onSubmit = (data) => {
        if (values?.formType == 'singIn'){
            const info = JSON.stringify({...data, role: 'admin'})
            const fetchData = async() => {
                try{
                    const response = await DoctorService.enter(info)

                    if (!response.status == 200){
                        throw new Error('Network response was not ok');
                    }

                    const data1 = await response.json();
                } catch(error){
                    console.log('There was a problem with the fetch operation:', error);
                }
            };

            fetchData()
        } else {
            if (values.dataType === 'doctor' && values.formType === 'CISH'){
                onChange({
                    ...data,
                    "sign": signData,
                    "table": tableInput
                })
            } else if (values.dataType === 'doctor' && values.formType !== 'CISH'){
                onChange({
                    ...data,
                    "sign": signData
                })
            } else {
                onChange(data);
            }
            setDataInputs(data);
        }
    }

    // Doc gistology buttons starts

    const smallFormTable = () => {
        setSmallForm(true)
    }

    const cutHandler = () => {
        setChange(true)
    }

    const printLabelHandler = () => {
        if (values.formType === 'Gistology'){
            let arr = []
            let quant = document.querySelectorAll('[placeholder="Введіть опис"]')
            for(let i = 0; i < quant.length; i++){
                arr.push({
                    "label": form
                })
            }
            setLabels(arr)
            setPrint(true)
            onPrinted(true)
        } else if (values.formType === 'Express'){
            let arr = []
            let quant = form.quantityMaterial
            for(let i = 0; i < quant; i++){
                arr.push({
                    "label": form
                })
            }
            setLabels(arr)
            setPrint(true)
            onPrinted(true)
        }
    }
    
    useEffect(()=>{
        getLabCard(form.id)
    },[values])
    
      const getLabCard = async(id) =>{
        if(values.dataType === 'laborant'){
            await laborantService.getDirection(id).then(res=>{
            if(res?.data && res?.data.laboratoryForm.data.description !== null){
                setValue("description", `${res?.data.laboratoryForm.data.description}`)
            }
            if(res?.data && res?.data.laboratoryForm.data.cassettes?.length > 0){
                for(let i = 1; i <= res?.data.laboratoryForm.data.cassettes.length; i++){
                    let inputs = document.querySelector(`[name="cassets${i}"]`)
                    setValue(`cassets${i}`, `${res?.data.laboratoryForm.data.cassettes[i-1]}`)
                    inputs.setAttribute("disabled", "disabled");;
                }
            }
            })
        }
      }

      const changeType = useSelector(state=>state.RegScan.ScanInputs.type)

      useEffect(()=>{
        if(values.dataType === 'doctor' && changeType === 'change'){
            DoctorService.getDirection(id).then(res=>{
                if(res?.data){
                    let data = res?.data.doctorForm.data
                    for (const key in data){
                        if(key === 'difficultyLevel'){
                            setValue('level', data[key])
                        } else{
                        setValue(`${key}`, data[key])
                        }
                    }
                    setValue('doc', 12)
                }
            })
        }
      },[values])

      useEffect(()=>{
        setTableForm(values.fields)
      },[values.fields])

    return (
        <>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                {values.dataType === 'doctor' && changeType !== 'change' && values.formType === 'Гістологія' && <div className={classes.form__doctor__iconsBox}>
                        <Paint onClick={() => {
                            cutHandler()
                        }} className={classes.icon}/>
                        <DryCut onClick={() => {
                            cutHandler()
                        }} className={classes.icon}/>
                        <WetCut onClick={() => {
                            cutHandler()
                        }} className={classes.icon}/>
                        <DisplayForm onClick={() => {
                            smallFormTable()
                        }} onclassName={classes.icon}/>
                </div>}
                {values.dataType === 'doctor' && values.formType === 'Експрес' && 
                    <div className={classes.form__doctor__iconsBox}><DisplayForm onClick={() => {
                        smallFormTable()
                        }} className={classes.icon}/>
                    </div>}
                {values.dataType === 'laborant' && values.formType === 'Gistology' && <div className={classes.form__doctor__iconsBox}>
                    <PrintIcon onClick={() => {
                        printLabelHandler()
                    }} className={classes.icon}/>
                    <DryCut onClick={() => {
                        cutHandler()
                    }} className={classes.icon}/>
                </div>
                }
                    {values.dataType === 'laborant' && values.formType === 'Express' && <div className={classes.form__doctor__iconsBox}>
                        <PrintIcon onClick={() => {
                            printLabelHandler()
                        }} className={classes.icon}/>
                    </div>
                    }
                    {values.formType == 'logIn' ? (
                        <div className={classes.form__wrapper}>
                            <div className={classNames(classes.form__title, {[classes.active]: values.formType == 'logIn'})}>
                                Вхід
                            </div>

                        </div>
                    ) : (
                        <h1 className={classes.form__title}>{values.title}</h1>
                    )}
                    {tableForm.length > 0 && tableForm.map((el, index) => (
                       <div className={classes[values.class]} key={index}>
                            {el.name !== 'doc'&&  el.name !== 'conclusionTable' && <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>}
                            {(changeType !== 'change' && el.name === 'doc') || (changeType !== 'change' && el.name === 'conclusionTable')  && <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>}
                            <div
                                className={classNames(el.name == 'cassetsAfter' ? classes.form__input__cassets : classes.form__label__container, {[classes.register__container]: values.formType == 'singIn'})}>
                                {el.options ? changeType !== 'change' && (
                                    <Controller
                                        control={control}
                                        name={el.name}
                                        render={({field: {onChange, value}}) => (
                                            <Select
                                                className={classes.select}
                                                options={el.props}
                                                value={value ? value : []}
                                                onChange={onChange}
                                                required
                                                disableSearch
                                                hasSelectAll={false}
                                                placeholder={el.name === 'doc' ? 'Оберіть лікаря...' : 'Оберіть лаборанта...'}
                                            />
                                        )}
                                    />
                                ) : (
                                    el.props.map((props, i) => (
                                        <div
                                            className={classNames(classes.form__label__container__box, {[classes.register__container]: values.formType == 'singIn'})}
                                            key={'a' + i}>
                                            <div><label>{props.label}</label></div>
                                            <div className={el.name == 'cassetsAfter' ? classes.form__input__cassets : {}}>
                                                {(el.name !== 'sign' && el.name !== 'conclusionTable' && el.type !== 'textarea') && <input
                                                    className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                                    type={props.type}
                                                    min={props.min}
                                                    max={props.max}
                                                    disabled={
                                                        el.name === 'level'
                                                            ? changeType === 'change' ? true
                                                                : levelsQuant[props.label - 1] === 0
                                                                    ? true
                                                                    : false
                                                            : props.show
                                                    }
                                                    placeholder={props.placeholder}
                                                    pattern={props.pattern}
                                                    value={el.type == 'radio' ? props.label : props.value}
                                                    {...register(el.name == 'age' || el.name == 'cassetsAfter' ? props.register : el.name, {required: el.required})}
                                                />
                                                }
                                                {el.type === 'textarea' && <textarea
                                                    className={classNames(classes.form__textarea, {[classes.errorInput]: errors[el.name]})}
                                                    type={props.type}
                                                    min={props.min}
                                                    max={props.max}
                                                    disabled={props.show}
                                                    placeholder={props.placeholder}
                                                    pattern={props.pattern}
                                                    value={el.type == 'radio' ? props.label : props.value}
                                                    {...register(el.name == 'age' || el.name == 'cassetsAfter' ? props.register : el.name, {required: el.required})}
                                                />}
                                                {changeType !== 'change' && el.name === 'conclusionTable' &&
                                                    <AddCircleOutlineIcon onClick={() => {
                                                        setTable(true)
                                                    }} className={classes.icon}></AddCircleOutlineIcon>}
                                                {errors[el.name] && el.type !== 'radio' && (
                                                    <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                                                        Це поле є обов'язковим
                                                    </p>
                                                )}

                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    ))}
                    <div className={classes.form__label__container}>
                       {/* <button className={classes.form__button} type="button" onClick={() => 
                        {setSign(true)}}>Підписати</button>  */}
                       <button className={classes.form__button} type="submit">{values.button}</button>
                    </div>
            </form>
            {table && <TableInput setOutPutTable={setTableInput} onChange={onCloseDoc}/>}
            {print && <TablePrint onClose={closePrint} labels={labels}/>}
            {/* {sign && <Signature setOutPut={setSignData} onSign={closeSign}/>} */}
            {smallForm && <SmallLabForm onChange={onChangeClose}/>}
            {change && <CassetsEdit onEdited={setEdited} onChange={onCloseDoc} type={values.dataType}/>}
        </>
    );
}

export default Form;
